export const sleep = async (durationInMs: number) => {
  return new Promise((res) => setTimeout(res, durationInMs));
};
